import React from 'react';
import { Link } from 'react-router-dom';

const Support = () => (
  <div style={s.page}>
    <div style={s.container}>
      <header style={s.header}>
        <Link to="/" style={s.brand}>MyCarCollection</Link>
        <h1 style={s.title}>Support</h1>
        <p style={s.subtitle}>
          Need help? Have feedback? Found a bug? We're here to help.
        </p>
      </header>

      <section style={s.section}>
        <h2 style={s.sectionTitle}>Contact us</h2>
        <p style={s.text}>
          Email{' '}
          <a href="mailto:support@mycarcollection.app" style={s.link}>
            support@mycarcollection.app
          </a>
          . We aim to respond within 48 hours.
        </p>
      </section>

      <section style={s.section}>
        <h2 style={s.sectionTitle}>Frequently asked questions</h2>

        <div style={s.faq}>
          <h3 style={s.q}>How do I delete my account?</h3>
          <p style={s.text}>
            Open the app and go to <strong>Profile</strong> →{' '}
            <strong>Settings (gear icon)</strong> → <strong>Account</strong> →{' '}
            <strong>Permanently Delete Account</strong>. This permanently removes
            your account, garage, posts, and all related data.
          </p>
        </div>

        <div style={s.faq}>
          <h3 style={s.q}>How do I report a bug or send feedback?</h3>
          <p style={s.text}>
            In the app: <strong>Profile</strong> → <strong>Settings</strong> →{' '}
            <strong>Report / Feedback</strong>. Or email us at{' '}
            <a href="mailto:support@mycarcollection.app" style={s.link}>
              support@mycarcollection.app
            </a>{' '}
            with details and a screenshot if possible.
          </p>
        </div>

        <div style={s.faq}>
          <h3 style={s.q}>How do I report inappropriate content?</h3>
          <p style={s.text}>
            Tap the <strong>···</strong> menu on any post, vehicle, comment, or
            user profile and select <strong>Report</strong>. Our team reviews
            reports within 24 hours and takes action when content violates our
            community guidelines.
          </p>
        </div>

        <div style={s.faq}>
          <h3 style={s.q}>I forgot my password — how do I reset it?</h3>
          <p style={s.text}>
            On the login screen, tap <strong>Forgot password</strong> and follow
            the email instructions. If you signed up with Apple, Google, or
            Discord, sign in using that same provider — there's no separate
            password to reset.
          </p>
        </div>

        <div style={s.faq}>
          <h3 style={s.q}>How do I change my password?</h3>
          <p style={s.text}>
            <strong>Profile</strong> → <strong>Settings</strong> →{' '}
            <strong>Change Password</strong>. (Not available for accounts
            created via Apple, Google, or Discord — manage those through the
            provider.)
          </p>
        </div>

        <div style={s.faq}>
          <h3 style={s.q}>How do I make my profile private?</h3>
          <p style={s.text}>
            <strong>Profile</strong> → <strong>Settings</strong> →{' '}
            <strong>Privacy</strong>. You can hide your garage value, set your
            account to private (followers must be approved), and control what's
            visible on your profile.
          </p>
        </div>

        <div style={s.faq}>
          <h3 style={s.q}>How do I block another user?</h3>
          <p style={s.text}>
            Open the user's profile, tap the <strong>···</strong> menu in the
            top right, and choose <strong>Block</strong>. Blocked users can't
            see your profile, message you, or interact with your content.
          </p>
        </div>

        <div style={s.faq}>
          <h3 style={s.q}>How is my data used?</h3>
          <p style={s.text}>
            See our <Link to="/privacy" style={s.link}>Privacy Policy</Link> for full
            details on what we collect, how it's stored, and your rights.
          </p>
        </div>
      </section>

      <footer style={s.footer}>
        <p style={s.footerText}>
          Still need help? Email{' '}
          <a href="mailto:support@mycarcollection.app" style={s.link}>
            support@mycarcollection.app
          </a>
        </p>
        <p style={s.footerSmall}>
          MyCarCollection &middot;{' '}
          <Link to="/privacy" style={s.linkMuted}>Privacy Policy</Link>
        </p>
      </footer>
    </div>
  </div>
);

const s = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#0a0a0a',
    color: '#fff',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, sans-serif',
    padding: '48px 20px',
    boxSizing: 'border-box',
  },
  container: {
    maxWidth: 720,
    margin: '0 auto',
  },
  header: {
    marginBottom: 48,
    paddingBottom: 32,
    borderBottom: '1px solid rgba(255,255,255,0.08)',
  },
  brand: {
    color: 'rgba(255,255,255,0.6)',
    fontSize: 14,
    fontWeight: 600,
    textDecoration: 'none',
    letterSpacing: 0.2,
  },
  title: {
    fontSize: 42,
    fontWeight: 800,
    margin: '20px 0 12px',
    letterSpacing: -0.8,
  },
  subtitle: {
    fontSize: 16,
    color: 'rgba(255,255,255,0.6)',
    margin: 0,
    lineHeight: 1.5,
  },
  section: {
    marginBottom: 40,
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: 1,
    color: 'rgba(255,255,255,0.5)',
    marginBottom: 16,
  },
  faq: {
    marginBottom: 28,
  },
  q: {
    fontSize: 17,
    fontWeight: 600,
    margin: '0 0 8px',
    color: '#fff',
    letterSpacing: -0.2,
  },
  text: {
    fontSize: 15,
    lineHeight: 1.6,
    color: 'rgba(255,255,255,0.8)',
    margin: 0,
  },
  link: {
    color: '#5b7fff',
    textDecoration: 'none',
    fontWeight: 500,
  },
  linkMuted: {
    color: 'rgba(255,255,255,0.6)',
    textDecoration: 'none',
  },
  footer: {
    marginTop: 64,
    paddingTop: 32,
    borderTop: '1px solid rgba(255,255,255,0.08)',
    textAlign: 'center',
  },
  footerText: {
    fontSize: 14,
    color: 'rgba(255,255,255,0.7)',
    margin: '0 0 12px',
  },
  footerSmall: {
    fontSize: 12,
    color: 'rgba(255,255,255,0.4)',
    margin: 0,
  },
};

export default Support;
